import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Moyenne par période /semestre d'une classe
export const getClassAverageByEvaluationPeriod = async (paylod, context) => {
  // const { periodeEvaluationID, id_class, includeResit } = req.body;
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate/graduation/semestre`,
    paylod,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Moyenne par Année
export const getClassAverageByYear = async (paylod, context) => {
  // const { id_class, includeResit } = req.body;
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate/graduation/year`,
    paylod,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Moyenne par promotion
export const getAverageByPromotion = async (paylod, context) => {
  // const {cycle, yearLevels } = req.body;
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate/graduation`,
    paylod,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
